// @ts-nocheck
import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { GetWarehousesApiParameter } from "@insite/client-framework/Services/WarehouseService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import validatePassword from "@insite/client-framework/Store/CommonHandlers/ValidatePassword";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { getWarehousesDataView } from "@insite/client-framework/Store/Data/Warehouses/WarehousesSelectors";
import translate from "@insite/client-framework/Translate";
import { StateModel, WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { CountryModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import FormWrapper from "@store/Library/Components/Toolkit/FormWrapper";
import { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import Checkbox, { CheckboxPresentationProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import LoadingOverlay, { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import ReCaptcha from "@store/Overrides/Components/ReCaptcha";
import { formFieldDescriptionWrapperStyles } from "@store/Themes/common/mixins/formField";
import { formGridProps } from "@store/Themes/common/props/form";
import { requirementsGridProps } from "@store/Themes/common/props/requirementsGrid";
import requestNewAccount from "@store/Framework/Store/Store/Data/Accounts/Handlers/RequestAccess";
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { overrideSpacingStyles } from "@toolkit/Themes/common/mixins";
import React, { RefObject, useContext, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const reCaptchaLocation = "CreateAccount";

interface CompanyTypeModel {
    fields: {
        companyId: string;
        companyName: string;
    };
}

const enum fields {
    companyTypes = "companyTypes",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.companyTypes]: CompanyTypeModel[];
    };
}

const mapDispatchToProps = {
    requestNewAccount,
    validatePassword,
    validateReCaptcha: makeHandlerChainAwaitable<{ location: string; recaptchaRef: RefObject<ReCAPTCHA> }, boolean>(
        validateReCaptcha,
    ),
};

const getWarehousesParameter: GetWarehousesApiParameter = {
    search: "",
    latitude: 0,
    longitude: 0,
    pageSize: 20,
};

const mapStateToProps = (state: ApplicationState) => ({
    countries: getCurrentCountries(state),
    warehouses: getWarehousesDataView(state, getWarehousesParameter).value,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RequestAccessNewUserStyles {
    form?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    centeringWrapper?: InjectableCss;
    mainGridContainer?: GridContainerProps;
    mainGridItem?: GridItemProps;
    contentSectionContainer?: GridContainerProps;
    contentGridItem?: GridItemProps;
    accountSectionContainer?: GridContainerProps;
    accountHeadingGridItem?: GridItemProps;
    userGridContainer?: GridContainerProps;
    emailGridItem?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    userNameGridItem?: GridItemProps;
    userNameTextField?: TextFieldPresentationProps;
    submitErrorGridItem?: GridItemProps;
    submitErrorTitle?: TypographyProps;
    submitGridItem?: GridItemProps;
    reCaptchaGridItem?: GridItemProps;
    submitRequestButton?: ButtonPresentationProps;
    requirementsGridItem?: GridItemProps;
    requirementsTitle?: TypographyProps;
    submitErrorInfosBox?: InfosBoxProps;
    firstNameGridItem?: GridItemProps;
    lastNameGridItem?: GridItemProps;
    firstNameTextField?: TextFieldPresentationProps;
    lastNameTextField?: TextFieldPresentationProps;
    warehouseGridItem?: GridItemProps;
    warehouseSelect?: SelectPresentationProps;
    companyGridItem?: GridItemProps;
    companySelect?: SelectPresentationProps;
    sectionHeading?: TypographyProps;
    billingSectionContainer?: GridContainerProps;
    billingGridContainer?: GridContainerProps;
    billingInformationHeadingGridItem?: GridItemProps;
    billingFirstNameGridItem?: GridItemProps;
    billingFirstNameTextField?: TextFieldPresentationProps;
    billingLastNameGridItem?: GridItemProps;
    billingLastNameTextField?: TextFieldPresentationProps;
    billingAddress1GridItem?: GridItemProps;
    billingAddress1TextField?: TextFieldPresentationProps;
    billingAddress2GridItem?: GridItemProps;
    billingAddress2TextField?: TextFieldPresentationProps;
    billingCompanyGridItem?: GridItemProps;
    billingCompanyTextField?: TextFieldPresentationProps;
    billingCountryGridItem?: GridItemProps;
    billingCountrySelect?: SelectPresentationProps;
    billingStateGridItem?: GridItemProps;
    billingStateSelect?: SelectPresentationProps;
    billingCityGridItem?: GridItemProps;
    billingCityTextField?: TextFieldPresentationProps;
    billingPostalGridItem?: GridItemProps;
    billingPostalTextField?: TextFieldPresentationProps;
    billingPhoneGridItem?: GridItemProps;
    billingPhoneTextField?: TextFieldPresentationProps;
    billingWebsiteGridItem?: GridItemProps;
    billingWebsiteTextField?: TextFieldPresentationProps;
    shippingSectionContainer?: GridContainerProps;
    shippingInformationHeadingGridItem?: GridItemProps;
    shippingInformationCheckboxGridItem?: GridItemProps;
    shippingCheckbox?: CheckboxPresentationProps;
    shippingFirstNameGridItem?: GridItemProps;
    shippingFirstNameTextField?: TextFieldPresentationProps;
    shippingLastNameGridItem?: GridItemProps;
    shippingLastNameTextField?: TextFieldPresentationProps;
    shippingAddress1GridItem?: GridItemProps;
    shippingAddress1TextField?: TextFieldPresentationProps;
    shippingAddress2GridItem?: GridItemProps;
    shippingAddress2TextField?: TextFieldPresentationProps;
    shippingCompanyGridItem?: GridItemProps;
    shippingCompanyTextField?: TextFieldPresentationProps;
    shippingCountryGridItem?: GridItemProps;
    shippingCountrySelect?: SelectPresentationProps;
    shippingStateGridItem?: GridItemProps;
    shippingStateSelect?: SelectPresentationProps;
    shippingCityGridItem?: GridItemProps;
    shippingCityTextField?: TextFieldPresentationProps;
    shippingPostalGridItem?: GridItemProps;
    shippingPostalTextField?: TextFieldPresentationProps;
    shippingPhoneGridItem?: GridItemProps;
    shippingPhoneTextField?: TextFieldPresentationProps;
    shippingWebsiteGridItem?: GridItemProps;
    shippingWebsiteTextField?: TextFieldPresentationProps;
    termsSectionContainer?: GridContainerProps;
    termsGridContainer?: GridContainerProps;
    termsHeadingGridItem?: GridItemProps;
    termsZoneGridItem?: GridItemProps;
    acceptTermsGridItem?: GridItemProps;
    acceptTermsCheckbox?: CheckboxPresentationProps;
    acceptTermsError?: TypographyProps;
    loadingOverlay?: LoadingOverlayProps;
}

export const requestAccessNewUserStyles: RequestAccessNewUserStyles = {
    mainGridContainer: requirementsGridProps.container,
    mainGridItem: requirementsGridProps.formColumn,
    userGridContainer: formGridProps.gridContainer,
    contentSectionContainer: formGridProps.gridContainer,
    contentGridItem: { width: 12 },
    accountSectionContainer: formGridProps.gridContainer,
    accountHeadingGridItem: { width: 12 },
    emailGridItem: { width: 12 },
    userNameGridItem: { width: 12 },
    submitErrorGridItem: { width: 12 },
    submitErrorInfosBox: { type: "error" },
    firstNameGridItem: { width: 6 },
    lastNameGridItem: { width: 6 },
    warehouseGridItem: { width: 6 },
    companyGridItem: { width: 6 },
    sectionHeading: {
        variant: "h3",
        forwardAs: "h2",
        mergeCss: true,
        css: css`
            border-bottom: 2px solid ${getColor("primary")};
            width: 100%;
            ${overrideSpacingStyles(pxToRem(15), pxToRem(15))}
        `,
    },
    billingSectionContainer: formGridProps.gridContainer,
    billingGridContainer: formGridProps.gridContainer,
    billingInformationHeadingGridItem: { width: 12 },
    billingFirstNameGridItem: { width: 6 },
    billingLastNameGridItem: { width: 6 },
    billingAddress1GridItem: { width: 6 },
    billingAddress2GridItem: { width: 6 },
    billingCompanyGridItem: { width: 12 },
    billingCountryGridItem: { width: 6 },
    billingStateGridItem: { width: 6 },
    billingCityGridItem: { width: 6 },
    billingPostalGridItem: { width: 6 },
    billingPhoneGridItem: { width: 6 },
    billingWebsiteGridItem: { width: 6 },
    billingWebsiteTextField: { hintProps: { size: 12 } },
    shippingSectionContainer: formGridProps.gridContainer,
    shippingInformationHeadingGridItem: { width: 12 },
    shippingInformationCheckboxGridItem: { width: 12 },
    shippingFirstNameGridItem: { width: 6 },
    shippingLastNameGridItem: { width: 6 },
    shippingAddress1GridItem: { width: 6 },
    shippingAddress2GridItem: { width: 6 },
    shippingCompanyGridItem: { width: 12 },
    shippingCountryGridItem: { width: 6 },
    shippingStateGridItem: { width: 6 },
    shippingCityGridItem: { width: 6 },
    shippingPostalGridItem: { width: 6 },
    shippingPhoneGridItem: { width: 6 },
    shippingWebsiteGridItem: { width: 6 },
    shippingWebsiteTextField: { hintProps: { size: 12 } },
    termsSectionContainer: formGridProps.innerGridContainer,
    termsGridContainer: {
        gap: 0,
        offsetCss: css`
            margin-top: 0.75rem;
        `,
    },
    termsHeadingGridItem: { width: 12 },
    termsZoneGridItem: {
        width: 12,
        css: css`
            display: block;
            overflow-y: scroll;
            height: 15em;
            max-height: 50vh;
            border: 1px solid ${getColor("common.borderLight")};
            padding: 0.625rem;
            margin-bottom: 1rem !important;
        `,
    },
    acceptTermsGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    acceptTermsError: {
        css: css`
            ${formFieldDescriptionWrapperStyles()}
            color: ${getColor("danger")};
            margin-top: ${pxToRem(6)};
        `,
    },
};

const styles = requestAccessNewUserStyles;
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");
const StyledForm = getStyledWrapper("form");

const RequestAccessNewUser = ({
    requestNewAccount,
    validateReCaptcha,
    countries,
    warehouses,
    fields: { companyTypes },
    id,
}: Props) => {
    const displayTermsSection = useZoneIsActive(id, "TermsContent");
    const emailFieldMessage = siteMessage("RequestAccessNewUser_EmailAddress_ValidEmail");
    const websiteHintMessage = siteMessage("RequestAccessNewUser_Website_HintMessage");
    const toBillingLabel = (label: string) => translate("Billing {0}", label);
    const toShippingLabel = (label: string) => translate("Shipping {0}", label);

    const emailLabel = translate("Email Address");
    const emailRequiredMessage = siteMessage("Field_Required", emailLabel);
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(emailRequiredMessage);
    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    const firstNameLabel = translate("First Name");
    const firstNameRequiredMessage = siteMessage("Field_Required", firstNameLabel);
    const [firstName, setFirstName] = useState("");
    const [firstNameError, setFirstNameError] = useState(firstNameRequiredMessage);
    const validatefirstName = (firstName: string) => {
        const errorMessage = !firstName ? firstNameRequiredMessage : "";
        setFirstNameError(errorMessage);
        return !errorMessage;
    };

    const lastNameLabel = translate("Last Name");
    const lastNameRequiredMessage = siteMessage("Field_Required", lastNameLabel);
    const [lastName, setLastName] = useState("");
    const [lastNameError, setLastNameError] = useState(lastNameRequiredMessage);
    const validateLastName = (lastName: string) => {
        const errorMessage = !lastName ? lastNameRequiredMessage : "";
        setLastNameError(errorMessage);
        return !errorMessage;
    };

    const selectedWarehouseLabel = translate("Closest warehouse");
    const selectedWarehouseRequiredMessage = siteMessage("Field_Required", selectedWarehouseLabel);
    const [selectedWarehouse, setSelectedWarehouse] = useState<WarehouseModel | undefined>(undefined);
    const [selectedWarehouseError, setSelectedWarehouseError] = useState(selectedWarehouseRequiredMessage);
    const validateSelectedWarehouse = (selectedWarehouse: WarehouseModel | undefined) => {
        const errorMessage = !selectedWarehouse ? selectedWarehouseRequiredMessage : "";
        setSelectedWarehouseError(errorMessage);
        return !errorMessage;
    };

    const companyLabel = translate("Tell us about your company");
    const companyRequiredMessage = siteMessage("Field_Required", companyLabel);
    const [company, setCompany] = useState<string | undefined>(undefined);
    const [companyError, setCompanyError] = useState(companyRequiredMessage);
    const validateCompany = (company: string) => {
        const errorMessage = !company ? companyRequiredMessage : "";
        setCompanyError(errorMessage);
        return !errorMessage;
    };

    const billingFirstNameLabel = translate("First Name");
    const billingFirstNameRequiredMessage = siteMessage("Field_Required", toBillingLabel(billingFirstNameLabel));
    const [billingFirstName, setBillingFirstName] = useState("");
    const [billingFirstNameError, setBillingFirstNameError] = useState(billingFirstNameRequiredMessage);
    const validateBillingFirstName = (billingFirstName: string) => {
        const errorMessage = !billingFirstName ? billingFirstNameRequiredMessage : "";
        setBillingFirstNameError(errorMessage);
        return !errorMessage;
    };

    const billingLastNameLabel = translate("Last Name");
    const billingLastNameRequiredMessage = siteMessage("Field_Required", toBillingLabel(billingLastNameLabel));
    const [billingLastName, setBillingLastName] = useState("");
    const [billingLastNameError, setBillingLastNameError] = useState(billingLastNameRequiredMessage);
    const validateBillingLastName = (billingFirstName: string) => {
        const errorMessage = !billingFirstName ? billingLastNameRequiredMessage : "";
        setBillingLastNameError(errorMessage);
        return !errorMessage;
    };

    const billingCompanyLabel = translate("Company");
    const billingCompanyRequiredMessage = siteMessage("Field_Required", toBillingLabel(billingCompanyLabel));
    const [billingCompany, setBillingCompany] = useState("");
    const [billingCompanyError, setBillingCompanyError] = useState(billingCompanyRequiredMessage);
    const validateBillingCompany = (billingCompany: string) => {
        const errorMessage = !billingCompany ? billingCompanyRequiredMessage : "";
        setBillingCompanyError(errorMessage);
        return !errorMessage;
    };

    const billingAddress1Label = translate("Address 1");
    const billingAddress1RequiredMessage = siteMessage("Field_Required", toBillingLabel(billingAddress1Label));
    const [billingAddress1, setBillingAddress1] = useState("");
    const [billingAddress1Error, setBillingAddress1Error] = useState(billingAddress1RequiredMessage);
    const validateBillingAddress1 = (billingAddress1: string) => {
        const errorMessage = !billingAddress1 ? billingAddress1RequiredMessage : "";
        setBillingAddress1Error(errorMessage);
        return !errorMessage;
    };

    const [billingAddress2, setBillingAddress2] = useState("");

    const billingCountryLabel = translate("Country");
    const billingCountryRequiredMessage = siteMessage("Field_Required", toBillingLabel(billingCountryLabel));
    const [billingCountry, setBillingCountry] = useState<CountryModel | undefined>(undefined);
    const [billingCountryError, setBillingCountryError] = useState(billingCountryRequiredMessage);
    const validateBillingCountry = (billingCountry: CountryModel | undefined) => {
        const errorMessage = !billingCountry ? billingCountryRequiredMessage : "";
        setBillingCountryError(errorMessage);
        return !errorMessage;
    };

    const billingStateLabel = translate("Province");
    const billingStateRequiredMessage = siteMessage("Field_Required", toBillingLabel(billingStateLabel));
    const [billingStateOptions, setBillingStateOptions] = useState<StateModel[] | undefined>(undefined);
    const [billingState, setBillingState] = useState<StateModel | undefined>(undefined);
    const [billingStateError, setBillingStateError] = useState(billingStateRequiredMessage);
    const validateBillingState = (billingState: StateModel | undefined) => {
        const errorMessage = !billingState ? billingStateRequiredMessage : "";
        setBillingStateError(errorMessage);
        return !errorMessage;
    };

    const billingCityLabel = translate("City");
    const billingCityRequiredMessage = siteMessage("Field_Required", toBillingLabel(billingCityLabel));
    const [billingCity, setBillingCity] = useState("");
    const [billingCityError, setBillingCityError] = useState(billingCityRequiredMessage);
    const validateBillingCity = (billingCity: string) => {
        const errorMessage = !billingCity ? billingCityRequiredMessage : "";
        setBillingCityError(errorMessage);
        return !errorMessage;
    };

    const billingPostalLabel = translate("Postal Code");
    const billingPostalRequiredMessage = siteMessage("Field_Required", toBillingLabel(billingPostalLabel));
    const [billingPostal, setBillingPostal] = useState("");
    const [billingPostalError, setBillingPostalError] = useState(billingPostalRequiredMessage);
    const validateBillingPostal = (billingPostal: string) => {
        const errorMessage = !billingPostal ? billingPostalRequiredMessage : "";
        setBillingPostalError(errorMessage);
        return !errorMessage;
    };

    const billingPhoneLabel = translate("Phone");
    const billingPhoneRequiredMessage = siteMessage("Field_Required", toBillingLabel(billingPhoneLabel));
    const [billingPhone, setBillingPhone] = useState("");
    const [billingPhoneError, setBillingPhoneError] = useState(billingPhoneRequiredMessage);
    const validateBillingPhone = (billingPhone: string) => {
        const errorMessage = !billingPhone ? billingPhoneRequiredMessage : "";
        setBillingPhoneError(errorMessage);
        return !errorMessage;
    };

    const [billingWebsite, setBillingWebsite] = useState("");
    const [billingAsShipping, setBillingAsShipping] = useState(true);

    const shippingFirstNameLabel = translate("First Name");
    const shippingFirstNameRequiredMessage = siteMessage("Field_Required", toShippingLabel(shippingFirstNameLabel));
    const [shippingFirstName, setShippingFirstName] = useState("");
    const [shippingFirstNameError, setShippingFirstNameError] = useState(shippingFirstNameRequiredMessage);
    const validateShippingFirstName = (shippingFirstName: string) => {
        const errorMessage = !shippingFirstName ? shippingFirstNameRequiredMessage : "";
        setShippingFirstNameError(errorMessage);
        return !errorMessage;
    };

    const shippingLastNameLabel = translate("Last Name");
    const shippingLastNameRequiredMessage = siteMessage("Field_Required", toShippingLabel(shippingLastNameLabel));
    const [shippingLastName, setShippingLastName] = useState("");
    const [shippingLastNameError, setShippingLastNameError] = useState(shippingLastNameRequiredMessage);
    const validateShippingLastName = (shippingFirstName: string) => {
        const errorMessage = !shippingFirstName ? shippingLastNameRequiredMessage : "";
        setShippingLastNameError(errorMessage);
        return !errorMessage;
    };

    const shippingCompanyLabel = translate("Company");
    const shippingCompanyRequiredMessage = siteMessage("Field_Required", toShippingLabel(shippingCompanyLabel));
    const [shippingCompany, setShippingCompany] = useState("");
    const [shippingCompanyError, setShippingCompanyError] = useState(shippingCompanyRequiredMessage);
    const validateShippingCompany = (shippingCompany: string) => {
        const errorMessage = !shippingCompany ? shippingCompanyRequiredMessage : "";
        setShippingCompanyError(errorMessage);
        return !errorMessage;
    };

    const shippingAddress1Label = translate("Address 1");
    const shippingAddress1RequiredMessage = siteMessage("Field_Required", toShippingLabel(shippingAddress1Label));
    const [shippingAddress1, setShippingAddress1] = useState("");
    const [shippingAddress1Error, setShippingAddress1Error] = useState(shippingAddress1RequiredMessage);
    const validateShippingAddress1 = (shippingAddress1: string) => {
        const errorMessage = !shippingAddress1 ? shippingAddress1RequiredMessage : "";
        setShippingAddress1Error(errorMessage);
        return !errorMessage;
    };

    const [shippingAddress2, setShippingAddress2] = useState("");

    const shippingCountryLabel = translate("Country");
    const shippingCountryRequiredMessage = siteMessage("Field_Required", toShippingLabel(shippingCountryLabel));
    const [shippingCountry, setShippingCountry] = useState<CountryModel | undefined>(undefined);
    const [shippingCountryError, setShippingCountryError] = useState(shippingCountryRequiredMessage);
    const validateShippingCountry = (shippingCountry: CountryModel | undefined) => {
        const errorMessage = !shippingCountry ? shippingCountryRequiredMessage : "";
        setShippingCountryError(errorMessage);
        return !errorMessage;
    };

    const shippingStateLabel = translate("Province");
    const shippingStateRequiredMessage = siteMessage("Field_Required", toShippingLabel(shippingStateLabel));
    const [shippingStateOptions, setShippingStateOptions] = useState<StateModel[] | undefined>(undefined);
    const [shippingState, setShippingState] = useState<StateModel | undefined>(undefined);
    const [shippingStateError, setShippingStateError] = useState(shippingStateRequiredMessage);
    const validateShippingState = (shippingState: StateModel | undefined) => {
        const errorMessage = !shippingState ? shippingStateRequiredMessage : "";
        setShippingStateError(errorMessage);
        return !errorMessage;
    };

    const shippingCityLabel = translate("City");
    const shippingCityRequiredMessage = siteMessage("Field_Required", toShippingLabel(shippingCityLabel));
    const [shippingCity, setShippingCity] = useState("");
    const [shippingCityError, setShippingCityError] = useState(shippingCityRequiredMessage);
    const validateShippingCity = (shippingCity: string) => {
        const errorMessage = !shippingCity ? shippingCityRequiredMessage : "";
        setShippingCityError(errorMessage);
        return !errorMessage;
    };

    const shippingPostalLabel = translate("Postal Code");
    const shippingPostalRequiredMessage = siteMessage("Field_Required", toShippingLabel(shippingPostalLabel));
    const [shippingPostal, setShippingPostal] = useState("");
    const [shippingPostalError, setShippingPostalError] = useState(shippingPostalRequiredMessage);
    const validateShippingPostal = (shippingPostal: string) => {
        const errorMessage = !shippingPostal ? shippingPostalRequiredMessage : "";
        setShippingPostalError(errorMessage);
        return !errorMessage;
    };

    const shippingPhoneLabel = translate("Phone");
    const shippingPhoneRequiredMessage = siteMessage("Field_Required", toShippingLabel(shippingPhoneLabel));
    const [shippingPhone, setShippingPhone] = useState("");
    const [shippingPhoneError, setShippingPhoneError] = useState(shippingPhoneRequiredMessage);
    const validateShippingPhone = (shippingPhone: string) => {
        const errorMessage = !shippingPhone ? shippingPhoneRequiredMessage : "";
        setShippingPhoneError(errorMessage);
        return !errorMessage;
    };

    const [shippingWebsite, setShippingWebsite] = useState("");

    const acceptTermsLabel = translate("Accept terms and conditions");
    const acceptTermsRequiredMessage = siteMessage("Field_Required", acceptTermsLabel);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [acceptTermsError, setAcceptTermsError] = useState(acceptTermsRequiredMessage);
    const validateAcceptTerms = (acceptTerms: boolean) => {
        const errorMessage = !acceptTerms ? acceptTermsRequiredMessage : "";
        setAcceptTermsError(errorMessage);
        return !errorMessage;
    };

    const [errorMessage, setErrorMessage] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const toasterContext = useContext(ToasterContext);
    const recaptchaRef: RefObject<ReCAPTCHA> = React.createRef();

    const validateSubmitEnabled = () => {
        return !(
            emailError ||
            firstNameError ||
            lastNameError ||
            selectedWarehouseError ||
            companyError ||
            billingFirstNameError ||
            billingLastNameError ||
            billingCompanyError ||
            billingAddress1Error ||
            billingCountryError ||
            billingStateError ||
            billingCityError ||
            billingPostalError ||
            billingPhoneError ||
            shippingFirstNameError ||
            shippingLastNameError ||
            shippingCompanyError ||
            shippingAddress1Error ||
            shippingCountryError ||
            shippingStateError ||
            shippingCityError ||
            shippingPostalError ||
            shippingPhoneError ||
            acceptTermsError
        );
    };

    const emailChangeHandler = (email: string) => {
        validateEmail(email);
        setEmail(email);
    };
    const firstNameChangeHandler = (firstName: string) => {
        validatefirstName(firstName);
        setFirstName(firstName);
    };
    const lastNameChangeHandler = (lastName: string) => {
        validateLastName(lastName);
        setLastName(lastName);
    };
    const handleWarehouseChange: SelectProps["onChange"] = event => {
        const warehouse = warehouses?.find(w => w.name === event.target.value);
        validateSelectedWarehouse(warehouse);
        setSelectedWarehouse(warehouse);
    };
    const handleCompanyChange: SelectProps["onChange"] = event => {
        validateCompany(event.currentTarget.value);
        setCompany(event.currentTarget.value);
    };
    const billingFirstNameChangeHandler = (billingFirstName: string) => {
        validateBillingFirstName(billingFirstName);
        setBillingFirstName(billingFirstName);
        if (billingAsShipping) {
            validateShippingFirstName(billingFirstName);
            setShippingFirstName(billingFirstName);
        }
    };
    const billingLastNameChangeHandler = (billingLastName: string) => {
        validateBillingLastName(billingLastName);
        setBillingLastName(billingLastName);
        if (billingAsShipping) {
            validateShippingLastName(billingLastName);
            setShippingLastName(billingLastName);
        }
    };
    const billingCompanyChangeHandler = (billingCompany: string) => {
        validateBillingCompany(billingCompany);
        setBillingCompany(billingCompany);
        if (billingAsShipping) {
            validateShippingCompany(billingCompany);
            setShippingCompany(billingCompany);
        }
    };
    const billingAddress1ChangeHandler = (billingAddress1: string) => {
        validateBillingAddress1(billingAddress1);
        setBillingAddress1(billingAddress1);
        if (billingAsShipping) {
            validateShippingAddress1(billingAddress1);
            setShippingAddress1(billingAddress1);
        }
    };
    const billingAddress2ChangeHandler = (billingAddress2: string) => {
        setBillingAddress2(billingAddress2);
        if (billingAsShipping) {
            validateShippingAddress1(billingAddress2);
            setShippingAddress1(billingAddress2);
        }
    };
    const handleBillingCountryChange: SelectProps["onChange"] = event => {
        const billingCountry = countries?.find(c => c.id === event.target.value);
        validateBillingCountry(billingCountry);
        setBillingCountry(billingCountry);
        if (billingAsShipping) {
            validateShippingCountry(billingCountry);
            setShippingCountry(billingCountry);
        }
        if (billingCountry?.states) {
            setBillingStateOptions(billingCountry?.states);
            if (billingAsShipping) {
                setShippingStateOptions(billingCountry?.states);
            }
        }
    };
    const handleBillingStateChange: SelectProps["onChange"] = event => {
        const billingState = billingStateOptions?.find(s => s.id === event.target.value);
        validateBillingState(billingState);
        if (billingAsShipping) {
            validateShippingState(billingState);
        }
        if (billingState) {
            setBillingState(billingState);
            if (billingAsShipping) {
                setShippingState(billingState);
            }
        }
    };
    const billingCityChangeHandler = (billingCity: string) => {
        validateBillingCity(billingCity);
        setBillingCity(billingCity);
        if (billingAsShipping) {
            validateShippingCity(billingCity);
            setShippingCity(billingCity);
        }
    };
    const billingPostalChangeHandler = (billingPostal: string) => {
        validateBillingPostal(billingPostal);
        setBillingPostal(billingPostal);
        if (billingAsShipping) {
            validateShippingPostal(billingPostal);
            setShippingPostal(billingPostal);
        }
    };
    const billingWebsiteChangeHandler = (billingWebsite: string) => {
        setBillingWebsite(billingWebsite);
        if (billingAsShipping) {
            setShippingWebsite(billingWebsite);
        }
    };
    const billingPhoneChangeHandler = (billingPhone: string) => {
        validateBillingPhone(billingPhone);
        setBillingPhone(billingPhone);
        if (billingAsShipping) {
            validateShippingPhone(billingPhone);
            setShippingPhone(billingPhone);
        }
    };
    const billingAsShippingChangeHandler = (_: React.SyntheticEvent<Element, Event>, value: boolean) => {
        setBillingAsShipping(value);
    };
    const shippingFirstNameChangeHandler = (shippingFirstName: string) => {
        validateShippingFirstName(shippingFirstName);
        setShippingFirstName(shippingFirstName);
    };
    const shippingLastNameChangeHandler = (shippingLastName: string) => {
        validateShippingLastName(shippingLastName);
        setShippingLastName(shippingLastName);
    };
    const shippingCompanyChangeHandler = (shippingCompany: string) => {
        validateShippingCompany(shippingCompany);
        setShippingCompany(shippingCompany);
    };
    const shippingAddress1ChangeHandler = (shippingAddress1: string) => {
        validateShippingAddress1(shippingAddress1);
        setShippingAddress1(shippingAddress1);
    };
    const shippingAddress2ChangeHandler = (shippingAddress2: string) => {
        setShippingAddress2(shippingAddress2);
    };
    const handleShippingCountryChange: SelectProps["onChange"] = event => {
        const shippingCountry = countries?.find(c => c.id === event.target.value);
        validateShippingCountry(shippingCountry);
        setShippingCountry(shippingCountry);
        if (shippingCountry?.states) {
            setShippingStateOptions(shippingCountry?.states);
        }
    };
    const handleShippingStateChange: SelectProps["onChange"] = event => {
        const shippingState = shippingStateOptions?.find(s => s.id === event.target.value);
        validateShippingState(shippingState);
        if (shippingState) {
            setShippingState(shippingState);
        }
    };
    const shippingCityChangeHandler = (shippingCity: string) => {
        validateShippingCity(shippingCity);
        setShippingCity(shippingCity);
    };
    const shippingPostalChangeHandler = (shippingPostal: string) => {
        validateShippingPostal(shippingPostal);
        setShippingPostal(shippingPostal);
    };
    const shippingWebsiteChangeHandler = (shippingWebsite: string) => {
        setShippingWebsite(shippingWebsite);
    };
    const shippingPhoneChangeHandler = (shippingPhone: string) => {
        validateShippingPhone(shippingPhone);
        setShippingPhone(shippingPhone);
    };
    const acceptTermsChangeHandler = (_: React.SyntheticEvent<Element, Event>, value: boolean) => {
        validateAcceptTerms(!acceptTerms);
        setAcceptTerms(!acceptTerms);
    };

    const resetFormFields = () => {
        setEmail("");
        setFirstName("");
        setLastName("");
        setSelectedWarehouse(undefined);
        setCompany("");
        setBillingFirstName("");
        setBillingLastName("");
        setBillingCompany("");
        setBillingAddress1("");
        setBillingAddress2("");
        setBillingCountry(undefined);
        setBillingState(undefined);
        setBillingCity("");
        setBillingPostal("");
        setBillingWebsite("");
        setBillingPhone("");
        setShippingFirstName("");
        setShippingLastName("");
        setShippingCompany("");
        setShippingAddress1("");
        setShippingAddress2("");
        setShippingCountry(undefined);
        setShippingState(undefined);
        setShippingCity("");
        setShippingPostal("");
        setShippingWebsite("");
        setShippingPhone("");
        setAcceptTerms(false);
    };

    const onSuccessHandler = () => {
        setErrorMessage("");
        setIsSubmitting(false);
        setIsSubmitted(false);
        resetFormFields();
        toasterContext.addToast({
            body: translate("Account request submitted successfully!"),
            messageType: "success",
            timeoutLength: 9000,
        });
    };

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        if (!validateSubmitEnabled()) {
            return;
        }

        const isReCaptchaValid = await validateReCaptcha({ location: reCaptchaLocation, recaptchaRef });

        if (!isReCaptchaValid) {
            return;
        }

        setIsSubmitting(true);
        requestNewAccount({
            isExisting: false,
            isTermsAccepted: true,
            billing: {
                firstName: billingFirstName,
                lastName: billingLastName,
                company: billingCompany,
                address1: billingAddress1,
                address2: billingAddress2,
                country: billingCountry,
                state: billingState,
                city: billingCity,
                zip: billingPostal,
                phone: billingPhone,
                companyWebsite: billingWebsite,
            },
            shipping: {
                firstName: billingAsShipping ? billingFirstName : shippingFirstName,
                lastName: billingAsShipping ? billingLastName : shippingLastName,
                company: billingAsShipping ? billingCompany : shippingCompany,
                address1: billingAsShipping ? billingAddress1 : shippingAddress1,
                address2: billingAsShipping ? billingAddress2 : shippingAddress2,
                country: billingAsShipping ? billingCountry : shippingCountry,
                state: billingAsShipping ? billingState : shippingState,
                city: billingAsShipping ? billingCity : shippingCity,
                zip: billingAsShipping ? billingPostal : shippingPostal,
                phone: billingAsShipping ? billingPhone : shippingPhone,
                companyWebsite: billingAsShipping ? billingWebsite : shippingWebsite,
            },
            shippingSameAsBilling: billingAsShipping,
            user: {
                email,
                firstName,
                lastName,
                warehouse: selectedWarehouse === undefined ? "" : selectedWarehouse.name,
                companyType: company === undefined ? "" : company,
                validation: {
                    customerNumber: null,
                    orderNumber: "",
                },
            },
            onSuccess: onSuccessHandler,
            onError: error => {
                toasterContext.addToast({
                    body: error,
                    messageType: "danger",
                    timeoutLength: 9000,
                });
                setIsSubmitting(false);
            },
            onComplete(resultProps) {
                if (resultProps.apiResult?.successful) {
                    this.onSuccess?.();
                } else if (resultProps.apiResult?.errorMessage) {
                    this.onError?.(resultProps.apiResult.errorMessage);
                }
            },
        });
    };

    const isSubmitEnabled = validateSubmitEnabled();

    return (
        <LoadingOverlay loading={isSubmitting} {...styles.loadingOverlay}>
            <FormWrapper>
                <StyledForm {...styles.form} onSubmit={submitHandler} noValidate>
                    <GridContainer {...styles.mainGridContainer}>
                        <GridItem {...styles.mainGridItem}>
                            <GridContainer {...styles.contentSectionContainer}>
                                <GridItem {...styles.contentGridItem}>
                                    <Zone zoneName="Content" contentId={id} />
                                </GridItem>
                            </GridContainer>
                            <GridContainer {...styles.accountSectionContainer}>
                                <GridItem {...styles.accountHeadingGridItem}>
                                    <Typography {...styles.sectionHeading}>{translate("Account")}</Typography>
                                </GridItem>
                            </GridContainer>
                            <GridContainer {...styles.userGridContainer}>
                                <GridItem {...styles.emailGridItem}>
                                    <TextField
                                        {...styles.emailTextField}
                                        type="email"
                                        label={emailLabel}
                                        onChange={e => emailChangeHandler(e.currentTarget.value)}
                                        value={email}
                                        data-test-selector="requestAccessNewUser_email"
                                        maxLength={256}
                                        required
                                        error={isSubmitted && emailError}
                                    />
                                </GridItem>
                                <GridItem {...styles.firstNameGridItem}>
                                    <TextField
                                        {...styles.firstNameTextField}
                                        label={firstNameLabel}
                                        value={firstName}
                                        data-test-selector="requestAccessNewUser_firstName"
                                        onChange={e => firstNameChangeHandler(e.currentTarget.value)}
                                        error={isSubmitted && firstNameError}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.lastNameGridItem}>
                                    <TextField
                                        {...styles.lastNameTextField}
                                        label={lastNameLabel}
                                        value={lastName}
                                        data-test-selector="requestAccessNewUser_lastName"
                                        onChange={e => lastNameChangeHandler(e.currentTarget.value)}
                                        error={isSubmitted && lastNameError}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.warehouseGridItem}>
                                    <Select
                                        {...styles.warehouseSelect}
                                        label={selectedWarehouseLabel}
                                        value={selectedWarehouse?.name || ""}
                                        onChange={handleWarehouseChange}
                                        required
                                        error={isSubmitted && selectedWarehouseError}
                                        data-test-selector="requestAccessNewUser_warehouse"
                                    >
                                        <option value="">{translate("Select your closest warehouse")}</option>
                                        {warehouses?.map(warehouse => (
                                            <option key={warehouse.name} value={warehouse.name}>
                                                {`${warehouse.description} (${warehouse.city})`}
                                            </option>
                                        ))}
                                    </Select>
                                </GridItem>
                                <GridItem {...styles.companyGridItem}>
                                    <Select
                                        {...styles.companySelect}
                                        label={companyLabel}
                                        value={company}
                                        onChange={handleCompanyChange}
                                        required
                                        error={isSubmitted && companyError}
                                        data-test-selector="requestAccessNewUser_company"
                                    >
                                        <option value="">{translate("Select an option")}</option>
                                        {companyTypes?.map(companyType => (
                                            <option
                                                key={companyType.fields.companyId}
                                                value={companyType.fields.companyId}
                                            >
                                                {companyType.fields.companyName}
                                            </option>
                                        ))}
                                    </Select>
                                </GridItem>
                            </GridContainer>
                            <GridContainer {...styles.billingSectionContainer}>
                                <GridItem {...styles.billingInformationHeadingGridItem}>
                                    <Typography {...styles.sectionHeading}>
                                        {translate("Billing Information")}
                                    </Typography>
                                </GridItem>
                            </GridContainer>
                            <GridContainer {...styles.billingGridContainer}>
                                <GridItem {...styles.billingFirstNameGridItem}>
                                    <TextField
                                        {...styles.billingFirstNameTextField}
                                        label={billingFirstNameLabel}
                                        value={billingFirstName}
                                        data-test-selector="requestAccessNewUser_billingFirstName"
                                        onChange={e => billingFirstNameChangeHandler(e.currentTarget.value)}
                                        error={isSubmitted && billingFirstNameError}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.billingLastNameGridItem}>
                                    <TextField
                                        {...styles.billingLastNameTextField}
                                        label={billingLastNameLabel}
                                        value={billingLastName}
                                        data-test-selector="requestAccessNewUser_billingLastName"
                                        onChange={e => billingLastNameChangeHandler(e.currentTarget.value)}
                                        error={isSubmitted && billingLastNameError}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.billingCompanyGridItem}>
                                    <TextField
                                        {...styles.billingCompanyTextField}
                                        label={billingCompanyLabel}
                                        value={billingCompany}
                                        data-test-selector="requestAccessNewUser_billingCompany"
                                        onChange={e => billingCompanyChangeHandler(e.currentTarget.value)}
                                        error={isSubmitted && billingCompanyError}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.billingAddress1GridItem}>
                                    <TextField
                                        {...styles.billingAddress1TextField}
                                        label={billingAddress1Label}
                                        value={billingAddress1}
                                        data-test-selector="requestAccessNewUser_billingAddress1"
                                        onChange={e => billingAddress1ChangeHandler(e.currentTarget.value)}
                                        error={isSubmitted && billingAddress1Error}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.billingAddress2GridItem}>
                                    <TextField
                                        {...styles.billingAddress2TextField}
                                        label={translate("Address 2")}
                                        value={billingAddress2}
                                        data-test-selector="requestAccessNewUser_billingAddress2"
                                        onChange={e => billingAddress2ChangeHandler(e.currentTarget.value)}
                                    />
                                </GridItem>
                                <GridItem {...styles.billingCountryGridItem}>
                                    <Select
                                        {...styles.billingCountrySelect}
                                        label={billingCountryLabel}
                                        value={billingCountry?.id}
                                        data-test-selector="requestAccessNewUser_billingCountry"
                                        onChange={handleBillingCountryChange}
                                        error={isSubmitted && billingCountryError}
                                        required
                                    >
                                        <option value="">{translate("Select an option")}</option>
                                        {countries?.map(country => (
                                            <option key={country.id} value={country.id}>
                                                {country.name}
                                            </option>
                                        ))}
                                    </Select>
                                </GridItem>
                                <GridItem {...styles.billingStateGridItem}>
                                    <Select
                                        {...styles.billingStateSelect}
                                        label={billingStateLabel}
                                        value={billingState?.id}
                                        data-test-selector="requestAccessNewUser_billingState"
                                        onChange={handleBillingStateChange}
                                        error={isSubmitted && billingStateError}
                                        required
                                    >
                                        <option value="">{translate("Select an option")}</option>
                                        {billingStateOptions?.map(state => (
                                            <option key={state.id} value={state.id}>
                                                {state.name}
                                            </option>
                                        ))}
                                    </Select>
                                </GridItem>
                                <GridItem {...styles.billingCityGridItem}>
                                    <TextField
                                        {...styles.billingCityTextField}
                                        label={billingCityLabel}
                                        value={billingCity}
                                        data-test-selector="requestAccessNewUser_billingCity"
                                        onChange={e => billingCityChangeHandler(e.currentTarget.value)}
                                        error={isSubmitted && billingCityError}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.billingPostalGridItem}>
                                    <TextField
                                        {...styles.billingPostalTextField}
                                        label={billingPostalLabel}
                                        value={billingPostal}
                                        data-test-selector="requestAccessNewUser_billingPostal"
                                        onChange={e => billingPostalChangeHandler(e.currentTarget.value)}
                                        error={isSubmitted && billingPostalError}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.billingPhoneGridItem}>
                                    <TextField
                                        {...styles.billingPhoneTextField}
                                        label={billingPhoneLabel}
                                        value={billingPhone}
                                        data-test-selector="requestAccessNewUser_billingPhone"
                                        onChange={e => billingPhoneChangeHandler(e.currentTarget.value)}
                                        error={isSubmitted && billingPhoneError}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.billingWebsiteGridItem}>
                                    <TextField
                                        {...styles.billingWebsiteTextField}
                                        label={translate("Company website")}
                                        value={billingWebsite}
                                        data-test-selector="requestAccessNewUser_billingWebsite"
                                        onChange={e => billingWebsiteChangeHandler(e.currentTarget.value)}
                                        hint={websiteHintMessage}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer {...styles.shippingSectionContainer}>
                                <GridItem {...styles.shippingInformationHeadingGridItem}>
                                    <Typography {...styles.sectionHeading}>
                                        {translate("Shipping Information")}
                                    </Typography>
                                </GridItem>
                                <GridItem {...styles.shippingInformationCheckboxGridItem}>
                                    <Checkbox
                                        {...styles.shippingCheckbox}
                                        checked={billingAsShipping}
                                        onChange={billingAsShippingChangeHandler}
                                    >
                                        {translate("Same as billing information")}
                                    </Checkbox>
                                </GridItem>
                                {!billingAsShipping && (
                                    <>
                                        <GridItem {...styles.shippingFirstNameGridItem}>
                                            <TextField
                                                {...styles.shippingFirstNameTextField}
                                                label={shippingFirstNameLabel}
                                                value={shippingFirstName}
                                                data-test-selector="requestAccessNewUser_shippingFirstName"
                                                onChange={e => shippingFirstNameChangeHandler(e.currentTarget.value)}
                                                error={isSubmitted && shippingFirstNameError}
                                                required
                                            />
                                        </GridItem>
                                        <GridItem {...styles.shippingLastNameGridItem}>
                                            <TextField
                                                {...styles.shippingLastNameTextField}
                                                label={shippingLastNameLabel}
                                                value={shippingLastName}
                                                data-test-selector="requestAccessNewUser_shippingLastName"
                                                onChange={e => shippingLastNameChangeHandler(e.currentTarget.value)}
                                                error={isSubmitted && shippingLastNameError}
                                                required
                                            />
                                        </GridItem>

                                        <GridItem {...styles.shippingCompanyGridItem}>
                                            <TextField
                                                {...styles.shippingCompanyTextField}
                                                label={shippingCompanyLabel}
                                                value={shippingCompany}
                                                data-test-selector="requestAccessNewUser_shippingCompany"
                                                onChange={e => shippingCompanyChangeHandler(e.currentTarget.value)}
                                                error={isSubmitted && shippingCompanyError}
                                                required
                                            />
                                        </GridItem>
                                        <GridItem {...styles.shippingAddress1GridItem}>
                                            <TextField
                                                {...styles.shippingAddress1TextField}
                                                label={shippingAddress1Label}
                                                value={shippingAddress1}
                                                data-test-selector="requestAccessNewUser_shippingAddress1"
                                                onChange={e => shippingAddress1ChangeHandler(e.currentTarget.value)}
                                                error={isSubmitted && shippingAddress1Error}
                                                required
                                            />
                                        </GridItem>
                                        <GridItem {...styles.shippingAddress2GridItem}>
                                            <TextField
                                                {...styles.shippingAddress2TextField}
                                                label={translate("Address 2")}
                                                value={shippingAddress2}
                                                data-test-selector="requestAccessNewUser_shippingAddress2"
                                                onChange={e => shippingAddress2ChangeHandler(e.currentTarget.value)}
                                            />
                                        </GridItem>
                                        <GridItem {...styles.shippingCountryGridItem}>
                                            <Select
                                                {...styles.shippingCountrySelect}
                                                label={shippingCountryLabel}
                                                value={shippingCountry?.id}
                                                data-test-selector="requestAccessNewUser_shippingCountry"
                                                onChange={handleShippingCountryChange}
                                                error={isSubmitted && shippingCountryError}
                                                required
                                            >
                                                <option value="">{translate("Select an option")}</option>
                                                {countries?.map(country => (
                                                    <option key={country.id} value={country.id}>
                                                        {country.name}
                                                    </option>
                                                ))}
                                            </Select>
                                        </GridItem>
                                        <GridItem {...styles.shippingStateGridItem}>
                                            <Select
                                                {...styles.shippingStateSelect}
                                                label={shippingStateLabel}
                                                value={shippingState?.id}
                                                data-test-selector="requestAccessNewUser_shippingState"
                                                onChange={handleShippingStateChange}
                                                error={isSubmitted && shippingStateError}
                                                required
                                            >
                                                <option value="">{translate("Select an option")}</option>
                                                {shippingStateOptions?.map(state => (
                                                    <option key={state.id} value={state.id}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </Select>
                                        </GridItem>
                                        <GridItem {...styles.shippingCityGridItem}>
                                            <TextField
                                                {...styles.shippingCityTextField}
                                                label={shippingCityLabel}
                                                value={shippingCity}
                                                data-test-selector="requestAccessNewUser_shippingCity"
                                                onChange={e => shippingCityChangeHandler(e.currentTarget.value)}
                                                error={isSubmitted && shippingCityError}
                                                required
                                            />
                                        </GridItem>
                                        <GridItem {...styles.shippingPostalGridItem}>
                                            <TextField
                                                {...styles.shippingPostalTextField}
                                                label={shippingPostalLabel}
                                                value={shippingPostal}
                                                data-test-selector="requestAccessNewUser_shippingPostal"
                                                onChange={e => shippingPostalChangeHandler(e.currentTarget.value)}
                                                error={isSubmitted && shippingPostalError}
                                                required
                                            />
                                        </GridItem>
                                        <GridItem {...styles.shippingPhoneGridItem}>
                                            <TextField
                                                {...styles.shippingPhoneTextField}
                                                label={shippingPhoneLabel}
                                                value={shippingPhone}
                                                data-test-selector="requestAccessNewUser_shippingPhone"
                                                onChange={e => shippingPhoneChangeHandler(e.currentTarget.value)}
                                                error={isSubmitted && shippingPhoneError}
                                                required
                                            />
                                        </GridItem>
                                        <GridItem {...styles.shippingWebsiteGridItem}>
                                            <TextField
                                                {...styles.shippingWebsiteTextField}
                                                label={translate("Company website")}
                                                value={shippingWebsite}
                                                data-test-selector="requestAccessNewUser_shippingWebsite"
                                                onChange={e => shippingWebsiteChangeHandler(e.currentTarget.value)}
                                                hint={websiteHintMessage}
                                            />
                                        </GridItem>
                                    </>
                                )}
                            </GridContainer>
                            {displayTermsSection && (
                                <GridContainer {...styles.termsSectionContainer}>
                                    <GridItem {...styles.termsHeadingGridItem}>
                                        <Typography {...styles.sectionHeading}>
                                            {translate("Terms & Conditions")}
                                        </Typography>
                                    </GridItem>
                                </GridContainer>
                            )}
                            {displayTermsSection && (
                                <GridContainer {...styles.termsGridContainer}>
                                    <GridItem {...styles.termsZoneGridItem}>
                                        <Zone zoneName="TermsContent" contentId={id} />
                                    </GridItem>
                                    <GridItem {...styles.acceptTermsGridItem}>
                                        <Checkbox
                                            {...styles.acceptTermsCheckbox}
                                            checked={acceptTerms}
                                            onChange={acceptTermsChangeHandler}
                                        >
                                            {acceptTermsLabel}
                                        </Checkbox>
                                        {isSubmitted && acceptTermsError && (
                                            <Typography {...styles.acceptTermsError}>{acceptTermsError}</Typography>
                                        )}
                                    </GridItem>
                                </GridContainer>
                            )}
                            <ReCaptcha recaptchaRef={recaptchaRef} location={reCaptchaLocation} />
                            <FormActions>
                                <Button
                                    {...styles.submitRequestButton}
                                    type="submit"
                                    disabled={isSubmitting || (isSubmitted && !isSubmitEnabled)}
                                    data-test-selector="requestAccessNewUser_submitRequestButton"
                                >
                                    {translate("Submit Request")}
                                </Button>
                            </FormActions>
                        </GridItem>
                    </GridContainer>
                </StyledForm>
            </FormWrapper>
        </LoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestAccessNewUser),
    definition: {
        group: "Create Account",
        fieldDefinitions: [
            {
                name: fields.companyTypes,
                displayName: "Company Types",
                editorTemplate: "ListField",
                isRequired: true,
                getDisplay: x => x.fields.companyName,
                defaultValue: [
                    { fields: { companyId: 1, companyName: "Complete Sign Shop" } },
                    { fields: { companyId: 10, companyName: "Exhibits / Displays" } },
                    { fields: { companyId: 11, companyName: "Government" } },
                    { fields: { companyId: 12, companyName: "Traffic Account" } },
                    { fields: { companyId: 13, companyName: "Grand Format Print/Signs" } },
                    { fields: { companyId: 16, companyName: "Flexo & Offset" } },
                    { fields: { companyId: 2, companyName: "Instant Signs" } },
                    { fields: { companyId: 3, companyName: "TV / Film Production" } },
                    { fields: { companyId: 4, companyName: "Leasing / Equipment" } },
                    { fields: { companyId: 5, companyName: "Vehicle Graphics / Wraps" } },
                    { fields: { companyId: 6, companyName: "Glass / Plastics" } },
                    { fields: { companyId: 7, companyName: "Electrical Shop" } },
                    { fields: { companyId: 8, companyName: "Printer / Photomounter" } },
                    { fields: { companyId: 9, companyName: "Other / End User / Retail" } },
                ],
                fieldType: "Contextual",
                fieldDefinitions: [
                    {
                        name: "companyId",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "companyName",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
